import { takeLatest } from 'redux-saga';
import { put } from 'redux-saga/effects';
import {
  USUARIO_PERFIL_LISTAR_BEGIN,
  USUARIO_PERFIL_LISTAR_SUCCESS,
  USUARIO_PERFIL_LISTAR_FAILURE,
  USUARIO_PERFIL_LISTAR_DISMISS_ERROR,
} from './constants';
import * as Services from '../../../sdk/services';

export function listar(filter, callback) {
  // If need to pass args to saga, pass it with the begin action.
  return {
    type: USUARIO_PERFIL_LISTAR_BEGIN,
    filter,
    callback,
  };
}

export function dismissListarError() {
  return {
    type: USUARIO_PERFIL_LISTAR_DISMISS_ERROR,
  };
}

// worker Saga: will be fired on USUARIO_PERFIL_LISTAR_BEGIN actions
export function* doListar(action) {
  // If necessary, use argument to receive the begin action with parameters.
  let res;
  const UsuarioPerfilApi = new Services['UsuarioPerfilApi']();
  try {
    // Do Ajax call or other async request here. delay(20) is just a placeholder.
    res = yield UsuarioPerfilApi.find(action.filter);
  } catch (err) {
    yield put({
      type: USUARIO_PERFIL_LISTAR_FAILURE,
      data: { error: err },
    });

    if (action.callback) {
      action.callback(USUARIO_PERFIL_LISTAR_FAILURE);
    }
    return;
  }
  // Dispatch success action out of try/catch so that render errors are not catched.
  yield put({
    type: USUARIO_PERFIL_LISTAR_SUCCESS,
    data: res,
  });

  if (action.callback) {
    action.callback(USUARIO_PERFIL_LISTAR_SUCCESS);
  }
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchListar() {
  yield takeLatest(USUARIO_PERFIL_LISTAR_BEGIN, doListar);
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case USUARIO_PERFIL_LISTAR_BEGIN:
      return {
        ...state,
        registros: [],
        listarPending: true,
        listarError: null,
      };

    case USUARIO_PERFIL_LISTAR_SUCCESS:
      return {
        ...state,
        registros: action.data,
        listarPending: false,
        listarError: null,
      };

    case USUARIO_PERFIL_LISTAR_FAILURE:
      return {
        ...state,
        listarPending: false,
        listarError: action.data.error,
      };

    case USUARIO_PERFIL_LISTAR_DISMISS_ERROR:
      return {
        ...state,
        listarError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/usuario-perfil/redux/listar.js